import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'forums-list',
  templateUrl: './forums-list.component.html',
  styleUrls: ['./forums-list.component.scss'],
  animations: [slide]
})
export class ForumsListComponent implements OnInit {
  forums:  FirebaseListObservable<any[]>;
  selectedForum: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private dbService: DBService
  ) {

    this.forums = this.dbService.getForums();

  }

  ngOnInit() {
  }

  showForum(key: string) {
    this.router.navigate([`/forums/${key}`]);
  }

  onAddForumClicked() {
    this.selectedForum = null;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onEditForumClicked(forum, event) {
    event.stopPropagation();
    this.selectedForum = forum;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteForumClicked(forum, event) {
    event.stopPropagation();
    this.showModalBg = true;
    this.showDeleteModal = true;
    this.selectedForum = forum;
  }

  onConfirmDeleteForum() {
    this.onHideDeleteModal();
    this.dbService.deleteForum(this.selectedForum.$key);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

  accessControl(forum, acl) {
    if (forum.userLevels[acl] == true) {
      return "<span class='check'>✔</span>";
    } else {
      return "<span class='cross'>✖</span>";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/forums/forums-list/forums-list.component.ts